import videojs from "video.js";

const Button = videojs.getComponent("Button");

class SnapshotButton extends Button {
  constructor(player, options) {
    super(player, options);
    this.controlText("Snapshot");
    this.addClass("vjs-snapshot-button");
    this.el().innerHTML = "📸"; // εικονίδιο
  }

  handleClick() {
    const video = this.player().el().querySelector("video");
    if (!video) return;

    const canvas = document.createElement("canvas");
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext("2d");
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

    const link = document.createElement("a");
    link.href = canvas.toDataURL("image/png");
    link.download = "snapshot.png";
    link.click();
  }
}

videojs.registerComponent("SnapshotButton", SnapshotButton);

export default SnapshotButton;
